<template>
  <div id="app" :class="{ 'silver-app': true, 'page-shell': isSpecialPage }">
    <router-view @changeLanguage="changeLanguage" />
  </div>
</template>

<script>
import WalletState from "./state/WalletState";
import { saveRef } from "./utils/utils";

export default {
  name: "App",
  data() {
    return {
      currentMenuKey: "1",
      currentMenuText: "",
    };
  },
  computed: {
    isSpecialPage() {
      return this.$route && (
        this.$route.path.indexOf("/aitoken") === 0 ||
        this.$route.path === "/getbamboocoin" ||
        this.$route.path === "/record" ||
        this.$route.path === "/record_com" ||
        this.$route.path === "/withdrawal" ||
        this.$route.path === "/withdrawal_com" ||
        this.$route.path === "/language" ||
        this.$route.path === "/friends" ||
        this.$route.path === "/index"
      );
    },
  },
  mounted() {
    saveRef();
    WalletState.connetWallet();
  },
  methods: {
    changeLanguage() {
      this.currentMenuText = this.$t(`menu.list[${this.currentMenuKey - 1}].text`);
    },
    changeMenu(key) {
      this.currentMenuKey = key;
      this.currentMenuText = this.$t(`menu.list[${key - 1}].text`);
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  min-height: 100vh;
}

.silver-app {
  position: relative;
  min-height: 100vh;
  color: #20324a;
  background:
    radial-gradient(circle at 15% 8%, rgba(255, 255, 255, 0.96), transparent 28%),
    radial-gradient(circle at 82% 14%, rgba(180, 204, 235, 0.26), transparent 30%),
    linear-gradient(180deg, #f9fbff 0%, #dde6f2 100%);
}

.silver-app::before {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.36), transparent 22%),
    radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.6), transparent 36%);
  opacity: 0.85;
}
</style>
